export function addTime(time: string): string {
  // Разбиваем время на часы и минуты
  const [hoursStr, minutesStr] = time.split(':');
  let hours = parseInt(hoursStr, 10);
  let minutes = parseInt(minutesStr, 10);

  // Добавляем 1 час 30 минут
  hours += 1;
  minutes += 30;

  // Корректируем переполнение минут
  if (minutes >= 60) {
    hours += Math.floor(minutes / 60);
    minutes = minutes % 60;
  }

  // Корректируем переполнение часов (24-часовой формат)
  hours = hours % 24;

  // Форматируем результат с ведущими нулями
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}
